import { doc, setDoc } from 'firebase/firestore';
import { IEurReportSettings } from '../../../providers/settings/reports/eurReportSettingsProvider';
import { userAsPromise } from '../../../providers/userProvider';

/**
 * @description updates the EUR settings
 * @param settings
 * @returns
 */
export const updateEurSettings = async (
  settings: IEurReportSettings
): Promise<void> => {
  const user = await userAsPromise();

  const update: IEurReportSettings = {
    cmjTags: settings?.cmjTags ?? [],
    squatTags: settings?.squatTags ?? [],
    timeframe: settings?.timeframe,
  };
  return setDoc(
    doc(user.services.firestore, `userProfiles/${user.id}/settings/eurReport`),
    update,
    { merge: true }
  );
};
